import { useCallback } from "react";
import { NavigateOptions, useNavigate } from "react-router-dom";
import { authApi } from "../services/auth";

export function getRedirectUri() {
  return `${window.location.origin}/auth-callback.html`;
}

export const useAuth = () => {
  const navigate = useNavigate();

  const [loginWithAzureService] = authApi.useAzureLoginMutation();

  const logout = useCallback(
    (options?: NavigateOptions) => {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");

      navigate("/login", options);
    },
    [navigate]
  );

  const loginWithAzure = useCallback(
    async (code: string) => {
      // Always use the same redirect_uri as in the Azure login request
      const hostname = getRedirectUri();
      try {
        await loginWithAzureService({ code, hostname }).unwrap();
        sessionStorage.removeItem("ssoError");
        navigate("/");
      } catch (error: any) {
        // Show error in UI for debugging
        const msg = error?.data?.message || error?.message || JSON.stringify(error);
        sessionStorage.setItem("ssoError", msg);
        console.log("Azure SSO error:", msg);
      }
    },
    [loginWithAzureService, navigate]
  );

  return {
    logout,
    loginWithAzure,
  };
};
